/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Uploading_Scans_Coming_SoonInputs */

const en_mobile_uploading_scans_coming_soon = /** @type {(inputs: Mobile_Uploading_Scans_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading & converting scanned pages will be wired with the shared network layer.`)
};

const es_mobile_uploading_scans_coming_soon = /** @type {(inputs: Mobile_Uploading_Scans_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La carga y conversión de páginas escaneadas se conectará con la capa de red compartida.`)
};

/**
* | output |
* | --- |
* | "Uploading & converting scanned pages will be wired with the shared network layer." |
*
* @param {Mobile_Uploading_Scans_Coming_SoonInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_uploading_scans_coming_soon = /** @type {((inputs?: Mobile_Uploading_Scans_Coming_SoonInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Uploading_Scans_Coming_SoonInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_uploading_scans_coming_soon(inputs)
	return en_mobile_uploading_scans_coming_soon(inputs)
});